import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TableRefreshButtonEnum } from './table-refresh-button.enum';

@Injectable({ providedIn: 'root' })
export class TableRefreshButtonService {
    readonly refresh$: Subject<TableRefreshButtonEnum> = new Subject<TableRefreshButtonEnum>();

    triggerRefresh(tableType: TableRefreshButtonEnum): void {
        this.refresh$.next(tableType);
    }
}
